<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik text-center">
      <h1 class="text-center">Geliştiriyoruz...</h1>
    </div>
  </div>

</template>

<script>
export default {
  created() {
    this.$store.dispatch("title", "Geliştiriyoruz");
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/comp/SayfaYok.vue